import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:hidden custom-title flex flex-col" }
const _hoisted_2 = { class: "ml-auto" }
const _hoisted_3 = { class: "flex items-center space-x-1" }
const _hoisted_4 = {
  key: 2,
  class: "w-full"
}
const _hoisted_5 = { class: "flex w-full justify-end mt-4" }
const _hoisted_6 = { class: "hidden md:block mr-3" }
const _hoisted_7 = { class: "md:hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InventorySearchForm = _resolveComponent("InventorySearchForm")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_OrganizationLevelInventoryList = _resolveComponent("OrganizationLevelInventoryList")!
  const _component_DepartmentLevelInventoryList = _resolveComponent("DepartmentLevelInventoryList")!
  const _component_DetailLevelInventoryList = _resolveComponent("DetailLevelInventoryList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_InventoryDialogs = _resolveComponent("InventoryDialogs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InventorySearchForm, {
              "model-value": _ctx.searchForm,
              "login-user-role": _ctx.loginUserRole || '',
              "login-user-role-is-head": _ctx.loginUserRoleIsHead,
              "onUpdate:modelValue": _ctx.handleSearchFormUpdate,
              onOrganizationIdChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchForm.organization_id = $event)),
              onSearch: _ctx.handleSearch,
              onAdd: _ctx.handleAdd,
              onExport: _ctx.handleExport,
              onImport: _ctx.handleImport
            }, null, 8, ["model-value", "login-user-role", "login-user-role-is-head", "onUpdate:modelValue", "onSearch", "onAdd", "onExport", "onImport"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, { style: {"padding":"0px","padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "在庫一覧（在庫数　アイテム名　有効期間）", -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSort2('material_name'))),
                    class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'material_name' ? 'active' : ''])
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" アイテム名 ")
                    ])),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSort2('quantity'))),
                    class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'quantity' ? 'active' : ''])
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode(" 在庫数 ")
                    ])),
                    _: 1
                  }, 8, ["class"]),
                  _createElementVNode("span", null, "アイテム数: " + _toDisplayString(_ctx.totalRecords), 1)
                ])
              ])
            ]),
            (_ctx.currentLevel === 1)
              ? (_openBlock(), _createBlock(_component_OrganizationLevelInventoryList, {
                  key: `org-${_ctx.tableKey}`,
                  ref: "organizationTableRef",
                  data: _ctx.tableData,
                  loading: _ctx.loading,
                  "login-user-role": _ctx.loginUserRole || '',
                  "login-user-role-is-head": _ctx.loginUserRoleIsHead,
                  "current-page": _ctx.currentPage,
                  "page-size": _ctx.pageSize,
                  "total-records": _ctx.totalRecords,
                  onEdit: _ctx.handleEditInventory,
                  onDelete: _ctx.handleDeleteInventory,
                  onAlarm: _ctx.handleAlarmInventory,
                  onConstant: _ctx.handleConstantInventory,
                  onExpand: _ctx.handleExpand,
                  onNestedExpand: _ctx.handleNestedExpand,
                  onCollapse: _ctx.handleCollapse,
                  onSort: _ctx.handleSort,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange,
                  onTransferInventory: _ctx.handleTransferInventory,
                  onQuantityUpdate: _ctx.handleQuantityUpdate
                }, null, 8, ["data", "loading", "login-user-role", "login-user-role-is-head", "current-page", "page-size", "total-records", "onEdit", "onDelete", "onAlarm", "onConstant", "onExpand", "onNestedExpand", "onCollapse", "onSort", "onSizeChange", "onCurrentChange", "onTransferInventory", "onQuantityUpdate"]))
              : (_ctx.currentLevel === 2)
                ? (_openBlock(), _createBlock(_component_DepartmentLevelInventoryList, {
                    key: `dept-${_ctx.tableKey}`,
                    ref: "departmentTableRef",
                    data: _ctx.tableData,
                    loading: _ctx.loading,
                    "login-user-role": _ctx.loginUserRole || '',
                    "login-user-role-is-head": _ctx.loginUserRoleIsHead,
                    "search-department-id": _ctx.searchDepartmentId || undefined,
                    "is-standalone": true,
                    "current-page": _ctx.currentPage,
                    "page-size": _ctx.pageSize,
                    "total-records": _ctx.totalRecords,
                    onEdit: _ctx.handleEditInventory,
                    onDelete: _ctx.handleDeleteInventory,
                    onAlarm: _ctx.handleAlarmInventory,
                    onConstant: _ctx.handleConstantInventory,
                    onExpand: _ctx.handleExpand,
                    onCollapse: _ctx.handleCollapse,
                    onQuantityUpdate: _ctx.handleQuantityUpdate,
                    onSort: _ctx.handleSort,
                    onSizeChange: _ctx.handleSizeChange,
                    onCurrentChange: _ctx.handleCurrentChange,
                    onTransferInventory: _ctx.handleTransferInventory
                  }, null, 8, ["data", "loading", "login-user-role", "login-user-role-is-head", "search-department-id", "current-page", "page-size", "total-records", "onEdit", "onDelete", "onAlarm", "onConstant", "onExpand", "onCollapse", "onQuantityUpdate", "onSort", "onSizeChange", "onCurrentChange", "onTransferInventory"]))
                : (_ctx.currentLevel === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(), _createBlock(_component_DetailLevelInventoryList, {
                        key: `detail-${_ctx.tableKey}`,
                        ref: "detailTableRef",
                        data: _ctx.tableData,
                        loading: _ctx.loading,
                        "is-standalone": true,
                        "current-page": _ctx.currentPage,
                        "page-size": _ctx.pageSize,
                        "total-records": _ctx.totalRecords,
                        onEdit: _ctx.handleEditInventory,
                        onDelete: _ctx.handleDeleteInventory,
                        onAlarm: _ctx.handleAlarmInventory,
                        onQuantityUpdate: _ctx.handleQuantityUpdate,
                        onSort: _ctx.handleSort,
                        onSizeChange: _ctx.handleSizeChange,
                        onCurrentChange: _ctx.handleCurrentChange,
                        onTransferInventory: _ctx.handleTransferInventory
                      }, null, 8, ["data", "loading", "current-page", "page-size", "total-records", "onEdit", "onDelete", "onAlarm", "onQuantityUpdate", "onSort", "onSizeChange", "onCurrentChange", "onTransferInventory"]))
                    ]))
                  : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.currentPage,
                  "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-size": _ctx.pageSize,
                  "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.totalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.totalRecords,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_InventoryDialogs, {
      "form-visible": _ctx.dialogFormVisible,
      "onUpdate:formVisible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      "alarm-visible": _ctx.dialogAlarmVisible,
      "onUpdate:alarmVisible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogAlarmVisible) = $event)),
      "constant-visible": _ctx.dialogConstantVisible,
      "onUpdate:constantVisible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogConstantVisible) = $event)),
      "image-preview-visible": _ctx.dialogVisible,
      "onUpdate:imagePreviewVisible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "transfer-inventory-visible": _ctx.dialogTransferInventoryVisible,
      "onUpdate:transferInventoryVisible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogTransferInventoryVisible) = $event)),
      "transfer-inventory-step": _ctx.transferInventoryStep,
      "onUpdate:transferInventoryStep": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.transferInventoryStep) = $event)),
      form: _ctx.form,
      "alarm-form": _ctx.alarmForm,
      "constant-form": _ctx.constantForm,
      "transfer-inventory-form": _ctx.transferInventoryForm,
      "target-inventory-list": _ctx.targetInventoryList,
      "target-inventory-list-loading": _ctx.targetInventoryListLoading,
      "selected-target-inventory-id": _ctx.selectedTargetInventoryId,
      "dialog-image-url": _ctx.dialogImageUrl,
      "file-list": _ctx.fileList,
      "form-show-del": _ctx.dialogFormShowDel,
      "login-user-role": _ctx.loginUserRole || '',
      "login-user-role-is-head": _ctx.loginUserRoleIsHead,
      errors: _ctx.errors,
      "constant-setting-level": _ctx.constantSettingLevel,
      "onUpdate:form": _ctx.handleFormUpdate,
      "onUpdate:alarmForm": _ctx.handleAlarmFormUpdate,
      "onUpdate:constantForm": _ctx.handleConstantFormUpdate,
      "onUpdate:transferInventoryForm": _ctx.handleTransferInventoryFormUpdate,
      onSubmit: _ctx.handleFormSubmit,
      onAlarmSubmit: _ctx.handleAlarmSubmit,
      onConstantSubmit: _ctx.handleConstantSubmit,
      onTransferInventorySubmit: _ctx.handleTransferInventorySubmit,
      onTransferInventoryRequestTargetInventoryList: _ctx.getTargetInventoryList,
      onTargetInventorySelect: _ctx.handleTargetInventorySelect,
      onDeleteReminder: _ctx.handleDeleteReminder,
      onImageChange: _ctx.handleImageChange,
      onImageRemove: _ctx.handleImageRemove,
      onImagePreview: _ctx.handleImagePreview,
      onScanStart: _ctx.handleScanStart,
      onJancodeSearch: _ctx.handleJancodeSearch,
      onCreateNewRecord: _ctx.handleCreateNewRecord,
      "onUpdate:errors": _ctx.handleErrorsUpdate,
      onOrganizationIdChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.organization_id = $event))
    }, null, 8, ["form-visible", "alarm-visible", "constant-visible", "image-preview-visible", "transfer-inventory-visible", "transfer-inventory-step", "form", "alarm-form", "constant-form", "transfer-inventory-form", "target-inventory-list", "target-inventory-list-loading", "selected-target-inventory-id", "dialog-image-url", "file-list", "form-show-del", "login-user-role", "login-user-role-is-head", "errors", "constant-setting-level", "onUpdate:form", "onUpdate:alarmForm", "onUpdate:constantForm", "onUpdate:transferInventoryForm", "onSubmit", "onAlarmSubmit", "onConstantSubmit", "onTransferInventorySubmit", "onTransferInventoryRequestTargetInventoryList", "onTargetInventorySelect", "onDeleteReminder", "onImageChange", "onImageRemove", "onImagePreview", "onScanStart", "onJancodeSearch", "onCreateNewRecord", "onUpdate:errors"])
  ], 64))
}